import React, { Fragment, Suspense } from 'react';
import PropTypes from 'prop-types';
import Component from './entity/Component';
import { getAnchorIdFromEntity } from './Anchor';
import LazyLoad from 'react-lazy-load';
import Loader from '../../adapters/helpers/Loader';
class Block extends Component {
  renderBlockFromDocument(extraAttributes, onClickCallback, customEvent, index) {
    const document = this.getDocument();
    if (document && document.fields && document.fields.contentType) {
      let contentType = document.fields.contentType;
      let blockName = document.fields.name;
      let className = document.fields.classNames;
      let attributes = {
        name: blockName,
        document: document,
        className: className,
        onClickCallback,
        customEvent,
        key: blockName,
        index,
        ...extraAttributes
      };
      return this.renderBlock(contentType, attributes, null);
    } else {
      var _this$props, _this$props$page, _this$props$page$fiel;
      console.error('Unsupported block is currently assign to page:' + ((_this$props = this.props) == null ? void 0 : (_this$props$page = _this$props.page) == null ? void 0 : (_this$props$page$fiel = _this$props$page.fields) == null ? void 0 : _this$props$page$fiel.name));
    }
  }

  /**
   * Render the modules assigned to the page.
   * @returns {*}
   */
  renderChildBlocks(extraAttributes, onClickCallback, customEvent) {
    const doc = this.getDocument();
    return doc.fields && doc.fields.blocks ? <Fragment>
    {doc.fields.blocks.map((child, index) => {
        var _child$fields;
        return (
          // Check if Lazy flag is available, else render the block as it is.
          (child == null ? void 0 : (_child$fields = child.fields) == null ? void 0 : _child$fields.hasOwnProperty('isLazy')) && child.fields.isLazy ?
          // Check if Lazy flag is false then render the first content, Else do lazy load for rest of the content
          <LazyLoad offset={100}>
          {new Block(child).renderBlockFromDocument(extraAttributes, onClickCallback, customEvent, index)}
        </LazyLoad> : new Block(child).renderBlockFromDocument(extraAttributes, onClickCallback, customEvent, index)
        );
      })}
  </Fragment> : null;
  }
  getAnchorId() {
    return getAnchorIdFromEntity(this.getDocument());
  }
  getShortName() {
    let shortName = this.getFieldValue('shortName');
    if (shortName == null) {
      shortName = this.getFieldValue('anchorId');
    }
    if (shortName == null) {
      shortName = this.getFieldValue('name');
    }
    return shortName;
  }
  renderSpecifiedBlock(blockToRender) {
    return blockToRender ? <Fragment>
        <Suspense fallback={<Loader />}>
        {blockToRender.map(child => new Block(child).renderBlockFromDocument())}
        </Suspense>
      </Fragment> : null;
  }
}
Block.propTypes = {
  page: PropTypes.object
};
export default Block;